import React from 'react';
import { ToastContainer } from 'react-toastify';

const Toasts = () => {
  return <ToastContainer autoClose={false} />;
};

export default Toasts;
